import Pubnub from 'pubnub'

import config from 'src/config'
import store from 'store'

const PUB_SUB_CHANNELS = {
  CHAT_MESSAGE: 'TL_PRO_USER_CHAT_MESSAGE_',
  CHAT_IS_TYPING: 'TL_PRO_USER_CHAT_IS_TYPING_',
}

const channelSubscriptions = {}

function onMessage(response) {
  if (channelSubscriptions[response.channel]) {
    const subscriptions = channelSubscriptions[response.channel]

    subscriptions.forEach((sub) => {
      sub.call(response, response.message)
    })
  }
}

class Pubsub {
  constructor() {
    this._client = new Pubnub({
      publishKey: config.PUBNUB_PUB_KEY,
      subscribeKey: config.PUBNUB_SUB_KEY,
      ssl: config.NODE_ENV !== 'local',
    })

    const listener = {
      signal: onMessage,
      message: onMessage,
    }

    this._client.addListener(listener)
  }

  subscribeToChatMessageChannel(userId, callback) {
    const currentVenue = store.state.venue.current

    const channel = `${PUB_SUB_CHANNELS.CHAT_MESSAGE}${currentVenue.id}_${userId}`

    return this._subscribe(channel, callback)
  }

  publishToIsTypingChannel(userId, message) {
    const currentVenue = store.state.venue.current

    const channel = `${PUB_SUB_CHANNELS.CHAT_IS_TYPING}${currentVenue.id}_${userId}`

    return this._client.signal({
      channel: channel,
      message,
    })
  }

  subscribeToIsTypingChannel(userId, callback) {
    const currentVenue = store.state.venue.current

    const channel = `${PUB_SUB_CHANNELS.CHAT_IS_TYPING}${currentVenue.id}_${userId}`

    return this._subscribe(channel, callback)
  }

  _subscribe(channel, listener) {
    if (!channelSubscriptions[channel]) {
      //only use Pubnub client.subscribe() once ever per channel
      this._client.subscribe({
        channels: [channel],
        restore: true, //STAY CONNECTED, EVEN WHEN BROWSER IS
      })
    }

    channelSubscriptions[channel] = channelSubscriptions[channel] || []
    channelSubscriptions[channel].push(listener)

    return {
      remove: () => {
        const subs = channelSubscriptions[channel]
        subs.splice(subs.indexOf(listener), 1)
      },
    }
  }
}

export default new Pubsub()



// WEBPACK FOOTER //
// ./src/lib/pubsub.js